import {
  OPEN_SIGNUP_MODAL,
  CLOSE_SIGNUP_MODAL,
  OPEN_COMPANY_SIGNUP_MODAL,
  OPEN_INFLUENCER_SIGNUP_MODAL
} from '../constants';

export const closeSignupModal = () => {
  return (dispatch, getState) => {
    dispatch({ type: CLOSE_SIGNUP_MODAL });
  };
};

export const openSignupModal = () => {
  return (dispatch, getState) => {
    dispatch({ type: OPEN_SIGNUP_MODAL });
  };
};

export const openCompanySignupModal = () => {
  return (dispatch, getState) => {
    dispatch({ type: OPEN_COMPANY_SIGNUP_MODAL });
  };
};

export const openInfluencerSignupModal = () => {
  return (dispatch, getState) => {
    dispatch({ type: OPEN_INFLUENCER_SIGNUP_MODAL });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/signupModalActions.js